import React from 'react';

// Distinct fill colours per SKU so the picker can see grouping at a glance.
// Deterministic hash → colour so the same SKU is always the same colour.
const COLOURS = [
  '#E5B764', '#7FB8E6', '#B4E67F', '#E67F9A', '#C57FE6',
  '#E6C67F', '#7FE6C7', '#E6907F', '#909FE6', '#B47FE6',
  '#E68A6C', '#6CE68A', '#E6E67F', '#7FE6E6', '#E67FBF',
];
const colourFor = (sku) => {
  let h = 0;
  for (let i = 0; i < sku.length; i += 1) h = (h * 31 + sku.charCodeAt(i)) & 0xffffffff;
  return COLOURS[Math.abs(h) % COLOURS.length];
};

// Top-down SVG diagram of a single carton layer. The carton floor is drawn to
// scale and each cylinder is a filled circle positioned by its (xMm, yMm)
// centre. Different SKUs get different fills — legend rendered separately by
// the caller. `sharedMaxMm` (optional) forces a plan-wide mm-to-px scale so a
// small carton doesn't get blown up to look bigger than a Large next to it.
const CartonDiagram = ({ carton, layerIndex = 0, maxPx = 340, sharedMaxMm = null }) => {
  const layer = carton?.layers?.[layerIndex];
  if (!layer) return null;
  const l = carton.lengthMm;
  const w = carton.widthMm;
  const referenceMm = sharedMaxMm || Math.max(l, w);
  const scale = maxPx / referenceMm;
  const pxL = l * scale;
  const pxW = w * scale;
  return (
    <svg
      width={pxL}
      height={pxW}
      viewBox={`0 0 ${l} ${w}`}
      className="bg-black/40 border border-border-color rounded"
      data-testid={`carton-diagram-${carton.cartonId}-layer-${layerIndex}`}
    >
      {/* carton floor grid marks: 100 mm intervals */}
      {Array.from({ length: Math.floor(l / 100) }, (_, i) => (
        <line key={`vx${i}`} x1={(i + 1) * 100} y1={0} x2={(i + 1) * 100} y2={w} stroke="#333" strokeWidth={1} />
      ))}
      {Array.from({ length: Math.floor(w / 100) }, (_, i) => (
        <line key={`hy${i}`} x1={0} y1={(i + 1) * 100} x2={l} y2={(i + 1) * 100} stroke="#333" strokeWidth={1} />
      ))}
      {layer.tubs.map((t, i) => (
        <g key={`t${i}`}>
          <circle
            cx={t.xMm} cy={t.yMm} r={t.diameterMm / 2}
            fill={colourFor(t.sku)} fillOpacity={0.85}
            stroke="#000" strokeWidth={1.5}
          />
        </g>
      ))}
    </svg>
  );
};

export const skuColour = colourFor;
export default CartonDiagram;
